import React from 'react'
import Containercontact from "../components/Containercontact"

function Contactus() {
  return (
    <div>
      < Containercontact />
    </div>
  )
}

export default Contactus